import {
  FabiJobSearchQueryGenerationUseCase,
  SearchMode,
} from '@xing-com/crate-common-graphql-types';
import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import { JobRecentSearchFragment } from '@xing-com/crate-jobs-graphql';
import { useRecentSearches } from '@xing-com/crate-jobs-hooks';

export const RECENT_SEARCHS_TITLE = 'recent-searches-title';
export type Suggestion =
  | FabiJobSearchQueryGenerationUseCase
  | typeof RECENT_SEARCHS_TITLE
  | JobRecentSearchFragment;

export const isItemDisabled = (item: Suggestion): boolean =>
  item === RECENT_SEARCHS_TITLE;

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useSuggestions = () => {
  const { isLoggedIn } = useLoginState();
  const { recentSearches, refetch } = useRecentSearches({
    searchMode: SearchMode.Semantic,
    skip: !isLoggedIn,
  });

  const suggestions: Suggestion[] = [
    FabiJobSearchQueryGenerationUseCase.EarnMore,
    FabiJobSearchQueryGenerationUseCase.SearchWithProfile,
    FabiJobSearchQueryGenerationUseCase.SearchWithSkills,
    ...(recentSearches?.length ? ([RECENT_SEARCHS_TITLE] as const) : []),
    ...(recentSearches ?? []).filter(Boolean),
  ];

  const refetchRecentSearches = (): void => {
    if (isLoggedIn) {
      refetch();
    }
  };

  return {
    suggestions,
    refetchRecentSearches,
  };
};
